module.exports = __webpack_public_path__ + "static/media/ambedkarlabfoundation.89776ad0.jpeg";